export default (excursionFromCb) => {
  const studentMedicalConditions = [];

  const { studentMedicalConditionInfo } = excursionFromCb?.metadata || {};

  if (studentMedicalConditionInfo && studentMedicalConditionInfo.mixedMedicalConditionHash) {
    const { mixedMedicalConditionHash } = studentMedicalConditionInfo;
    const mixedMedicalConditionHashKeyList = Object.keys(mixedMedicalConditionHash);

    for (let i = 0; i < mixedMedicalConditionHashKeyList.length; i += 1) {
      const mixedMedicalConditionHashKey = mixedMedicalConditionHashKeyList[i];
      const mixedMedicalConditionHashValue =
        mixedMedicalConditionHash[mixedMedicalConditionHashKey];

      const studentMedicalCondition = {
        name: mixedMedicalConditionHashKey,
        supported: mixedMedicalConditionHashValue.supported
      };

      const { orderIndex } = mixedMedicalConditionHashValue;
      if (typeof orderIndex !== 'undefined' && !studentMedicalConditions[orderIndex]) {
        studentMedicalConditions[orderIndex] = studentMedicalCondition;
      } else {
        studentMedicalConditions.push(studentMedicalCondition);
      }
    }
  }
  return studentMedicalConditions;
};
